/** Number formatting for the datasource card summary lines. */

export const formatValue = (value: number, decimalPlaces: number, prefix: string = "", suffix: string = "") => {
  // Handle NaN, null, undefined, and non-numeric values
  if (value == null || Number.isNaN(value)) {
    return "";
  }

  // Format the number with commas and decimal places
  const formattedValue = value.toLocaleString(undefined, {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  });

  // Return the formatted value with optional prefix and suffix
  return `${prefix}${formattedValue}${suffix ? " " + suffix : ""}`;
};

export const formatCurrency = (value: number): string => formatValue(value, 0, "$", "");

/** Currency abbreviated to one significant suffix (\$1.2M), for card summary lines. */
export const formatCompactCurrency = (value: number): string => {
  if (value == null || Number.isNaN(value)) return "";
  const magnitude = Math.abs(value);
  if (magnitude >= 1e9) return `$${(value / 1e9).toFixed(1)}B`;
  if (magnitude >= 1e6) return `$${(value / 1e6).toFixed(1)}M`;
  if (magnitude >= 1e3) return `$${(value / 1e3).toFixed(1)}K`;
  return formatCurrency(value);
};
